export default __webpack_public_path__ + "static/media/hero-img.14dc8f7a.png";